/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesSST {
	EMPLOYEE_EXAMINTATION = "res://senior.com.br/hcm/analytics_sst/entities/employeeExamination",
	WORK_ACCIDENT = "res://senior.com.br/hcm/analytics_sst/entities/workAccident",
	EMPLOYEE_PERSONAL_PROTECTIVE_EQUIPMENT = "res://senior.com.br/hcm/analytics_sst/entities/employeePersonalProtectiveEquipment",
	EMPLOYEE_COURSE = "res://senior.com.br/hcm/analytics_sst/entities/employeeCourse"
}

/**
 * Cards da página Manager, aba PayRoll
 */
export enum PermissionResourcesSSTManager {
	EMPLOYEE_EXAMINTATION = "res://senior.com.br/hcm/analytics_sst/entities/employeeExamination",
	WORK_ACCIDENT = "res://senior.com.br/hcm/analytics_sst/entities/workAccident",
	EMPLOYEE_PERSONAL_PROTECTIVE_EQUIPMENT = "res://senior.com.br/hcm/analytics_sst/entities/employeePersonalProtectiveEquipment",
	EMPLOYEE_COURSE = "res://senior.com.br/hcm/analytics_sst/entities/employeeCourse"
}
